module.exports = __webpack_public_path__ + "assets1783936157458/img/duolianyun.d685559e.svg";